import config from '../../../../config';
import Request from '../../../Request';

export default function sign(waiverId, id, signatureFile, signedByEmail, signedByName, onSuccess, onFailure) {
  let formData = new FormData()
  formData.append(`signature_file`, signatureFile)
  formData.append("signed_by_email", signedByEmail)
  formData.append("signed_by_name", signedByName)
  Request.patch(`${config.apiUrl}/waivers/${waiverId}/reservation_waivers/${id}/sign`, formData, onSuccess, onFailure);
}